import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {REQUEST_STATUS_NAMES, RequestStatus} from 'requests/RequestConstants';
import {RequestStatusIcon} from 'requests/RequestStatusIcon';

interface RequestStatusLabelProps {
  requestStatus: RequestStatus;
}
export default function RequestStatusLabel(props: RequestStatusLabelProps): JSX.Element {
  return (
    <span
      className={classNames('requestSampleStatusCounts-iconCount', {
        'requestStatusLabel--completed': props.requestStatus === RequestStatus.COMPLETED,
        'requestStatusLabel--inProgress': props.requestStatus === RequestStatus.IN_PROGRESS,
      })}
    >
      <RequestStatusIcon status={props.requestStatus} className={css(styles.statusIcon)} />
      {REQUEST_STATUS_NAMES[props.requestStatus]}
    </span>
  );
}

const styles = StyleSheet.create({
  statusIcon: {
    marginRight: '10px',
  },
});
